// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Om-z","badgeLink":"Pm-z","category":"Qm-z"};